var _rect, _path, _rect2, _rect3, _path2, _rect4, _rect5, _path3, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacateHouseCerti3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 70,
    viewBox: "0 0 100 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.6378,
    y: 22.9141,
    width: 60.855,
    height: 11.5131,
    fill: "#56BA74"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.4933 22.9141H87.5546V34.4272H75.4933V22.9141Z",
    fill: "#4A935E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 39.8574,
    y: 22.3672,
    width: 10.4166,
    height: 12.6096,
    fill: "#CAEADB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4767,
    y: 45.9375,
    width: 60.855,
    height: 11.5131,
    fill: "#56BA74"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3309 45.9375H91.3923V57.4506H79.3309V45.9375Z",
    fill: "#4E9A63"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.6951,
    y: 45.3906,
    width: 10.4166,
    height: 12.6096,
    fill: "#CAEADB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.60767,
    y: 34.4297,
    width: 60.855,
    height: 11.5131,
    fill: "#49AF68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4631 34.4297H81.5245V45.9428H69.4631V34.4297Z",
    fill: "#2A7940"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 33.8273,
    y: 33.8828,
    width: 10.4166,
    height: 12.6096,
    fill: "#C6E0D4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacateHouseCerti3);
export default __webpack_public_path__ + "static/media/VacateHouseCerti3.0da39f5ed4f20970d797c58c9ec9a53e.svg";
export { ForwardRef as ReactComponent };